var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.purchasePriceAvg && _vm.sellingPrice && _vm.getWeq(_vm.purchasePriceAvg,
  _vm.sellingPrice) > 0)?_c('span',[_vm._v(_vm._s(_vm.getWeq(_vm.purchasePriceAvg, _vm.sellingPrice))+" % ")]):_c('span',[_vm._v(" - ")])}
var staticRenderFns = []

export { render, staticRenderFns }